import React, { useEffect, useState } from "react";
import NavigationBar from "../components/Nav/navigationBar";
import { RoomData } from "../data/roomMock";
import {
  FaWind,
  FaBath,
  FaRegSnowflake,
  FaDoorOpen,
  FaRupeeSign,
  FaSortAlphaDown,
  FaSortAmountDown,
  FaArrowDown,
  FaArrowUp,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
function Home() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const tomorrow = new Date(Date.now() + 86400000).toISOString().split("T")[0];

  const [checkIn, setCheckIn] = useState(today);
  const [checkOut, setCheckOut] = useState(tomorrow);

  const [rooms, setRooms] = useState([]);
  const [sortedRooms, setSortedRooms] = useState(rooms);
  const [isPriceAscending, setIsPriceAscending] = useState(true);
  const [sortBy, setSortBy] = useState("name");
  const [filteredRooms, setFilteredRooms] = useState(rooms);

  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  const navigate = useNavigate();
  const fetchRooms = (inDate, outDate) => {
    fetch(
      `${BASE_URL}/room/getRooms.php?check_in=${inDate}&check_out=${outDate}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setRooms(data.data);
        } else {
          setError("Failed to load rooms");
        }
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setError("Error fetching rooms");
      });
  };
  useEffect(() => {
    if (checkIn && checkOut) {
      fetchRooms(checkIn, checkOut);
    }
  }, [checkIn, checkOut]);

  useEffect(() => {
    fetch(`${BASE_URL}/room/get-room-cat.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          console.log("Fetched categories:", data);
          setCategories(data.data);
        } else {
          setError("Failed to load categories");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error fetching categories");
        setLoading(false);
      });
  }, []);

  const getFeaturesFromCategory = (categoryName) => {
    let type = "Single Room";
    if (categoryName.includes("Suite")) type = "Suite";
    else if (categoryName.includes("Double Room")) type = "Double Room";

    const ac = categoryName.includes("No AC") ? "No AC" : "AC";
    const bath = categoryName.includes("Non-attached")
      ? "Non-attached Bathroom"
      : "Attached Bathroom";

    return { type, ac, bath };
  };
  const getImageForCategory = (categoryId) => {
    // Replace with actual image paths
    const images = {
      1: "../assets/rooms/suite/suite.jpg",
      2: "../assets/rooms/double/double.png",
      3: "../assets/rooms/double/no-ac.jpg",
      5: "../assets/rooms/single/ac.jpeg",
      6: "../assets/rooms/single/no-ac.jpeg",
    };
    return images[categoryId] || "/images/default.jpg";
  };

  // useEffect(() => {
  //   console.log(rooms);
  //   handleSort(sortBy); // Re-sort when the component mounts or sort option changes
  // }, [rooms, sortBy]); // Trigger sort when rooms or sort option changes
  useEffect(() => {
    let filtered = [...rooms];

    if (selectedCategory) {
      filtered = filtered.filter(
        (room) => String(room.category_id) === String(selectedCategory)
      );
    }

    // Apply sorting after filtering
    if (sortBy === "price") {
      filtered.sort((a, b) =>
        isPriceAscending ? a.price - b.price : b.price - a.price
      );
    } else if (sortBy === "name") {
      filtered.sort((a, b) => a.room_no.localeCompare(b.room_no));
    }

    setSortedRooms(filtered);
  }, [rooms, selectedCategory, sortBy, isPriceAscending]);

  const handleSort = (sortOption) => {
    if (sortOption === "price") {
      setIsPriceAscending(!isPriceAscending); // Toggle sort direction
    }
    setSortBy(sortOption);
  };

  const handleBookNow = (roomId) => {
    navigate(`/booking/${roomId}`);
  };
  return (
    <div className="overflow-x-hidden pt-48">
      <NavigationBar />
      
      <div className="relative w-3/4 mx-auto p-6 bg-white border border-black rounded-2xl shadow-lg overflow-hidden">
        {/* Background Image */}
        <img
          src="../assets/penukonda.jpg"
          alt="penukonda spots"
          className="absolute top-0 left-0 w-full h-full object-cover opacity-20 z-0"
        />

        {/* Content */}
        <div className="relative z-10">
          <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Book a Room
          </h1>

          <div className="flex flex-col md:flex-row gap-6">
            {/* Check-in */}
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Check-in Date
              </label>
              <input
                type="date"
                value={checkIn}
                min={today}
                onChange={(e) => {
                  setCheckIn(e.target.value);
                  if (e.target.value > checkOut) {
                    setCheckOut(e.target.value); // auto adjust check-out
                  }
                }}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            {/* Check-out */}
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Check-out Date
              </label>
              <input
                type="date"
                value={checkOut}
                min={checkIn}
                onChange={(e) => setCheckOut(e.target.value)}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            {/* Category Dropdown */}
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Room Category
              </label>
              {loading && <p>Loading categories...</p>}
              {error && <p className="text-red-500">{error}</p>}
              {!loading && !error && (
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                  <option value="">All Room Type</option>
                  {categories.map((cat) => (
                    <option key={cat.category_id} value={cat.category_id}>
                      {cat.category_name}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* rooms */}
      <div className="w-11/12 mx-auto py-10">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4 sm:gap-0">
          <h1 className="text-3xl font-bold text-gray-900">Available Rooms</h1>

          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3 w-full sm:w-auto">
            <label className="text-sm font-medium text-gray-600 whitespace-nowrap">
              Sort by:
            </label>

            <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 gap-2 w-full sm:w-auto">
              <button
                onClick={() => handleSort("price")}
                className={`flex items-center justify-center gap-1 px-4 py-2 rounded-md text-sm font-semibold w-full sm:w-auto
        ${
          sortBy === "price"
            ? "bg-blue-500 text-white"
            : "bg-gray-100 text-gray-700"
        }
        hover:bg-blue-500 hover:text-white transition-colors duration-300`}
              >
                {isPriceAscending ? <FaArrowDown /> : <FaArrowUp />} Price
              </button>

              <button
                onClick={() => handleSort("name")}
                className={`flex items-center justify-center gap-1 px-4 py-2 rounded-md text-sm font-semibold w-full sm:w-auto
        ${
          sortBy === "name"
            ? "bg-blue-500 text-white"
            : "bg-gray-100 text-gray-700"
        }
        hover:bg-blue-500 hover:text-white transition-colors duration-300`}
              >
                <FaSortAlphaDown /> Room Number
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {sortedRooms.map((room) => {
            const category = categories.find(
              (cat) => Number(cat.category_id) === Number(room.category_id)
            );
            const categoryName = category?.category_name || "Unknown";
            const { type, ac, bath } = getFeaturesFromCategory(categoryName);

            return (
              <div
                key={room.room_id}
                className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden transform transition-all hover:scale-105 hover:shadow-2xl"
              >
                {/* Room Image */}
                <img
                  src={getImageForCategory(room.category_id)}
                  alt={type}
                  className="w-full h-[250px] object-cover transition-transform transform hover:scale-110"
                />

                <div className="p-6">
                  {/* Room Details */}
                  <div className="flex justify-between items-center mb-5">
                    <h2 className="text-2xl font-semibold text-gray-800">
                      Room {room.room_no}
                    </h2>
                    <div className="text-xl font-semibold text-blue-600 flex items-center gap-1">
                      <FaRupeeSign />
                      <span className="text-2xl">{room.price}</span>
                    </div>
                  </div>

                  {/* Features */}
                  <div className="text-gray-600 mb-5 flex flex-wrap gap-4">
                    <div className="flex items-center gap-2 text-sm">
                      <FaDoorOpen className="text-gray-500" /> {type}
                    </div>
                    <div
                      className={`flex items-center gap-2 text-sm ${
                        ac === "AC" ? "text-blue-500" : "text-yellow-600"
                      }`}
                    >
                      {ac === "AC" ? <FaRegSnowflake /> : <FaWind />}
                      {ac}
                    </div>
                    <div
                      className={`flex items-center gap-2 text-sm ${
                        bath === "Attached Bathroom"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      <FaBath />
                      {bath}
                    </div>
                  </div>

                  {/* Book Now Button */}
                  <div className="mt-6">
                    <button
                      className="w-full bg-orange-100 text-orange-600 py-2 rounded-lg font-semibold hover:bg-orange-200 hover:text-orange-700 transition duration-300 ease-in-out border border-orange-200"
                      onClick={() => handleBookNow(room.room_id)}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Home;
